module.exports = __webpack_public_path__ + "img/keshihua.6b0f9335.jpg";